import classnames from "classnames";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { blockUi, unBlockUi } from "../../../actions/actionCreator";
import { aemHostClient, eapiClient } from "../../../restClient";
import { Translations, checkValueExistInObject, convertStringToArray, isEmptyObject } from "../../../utils";
import Checkbox from "../../common/Checkbox";
import { setSavedSow } from "../../createASow/actions/actionCreator";
import AddViewComments from "../AddViewComments";
import "./index.css";

class SowDocumentation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: this.props.sowDocData || [],
            pageJson: {},
            darkTitleBarJson: {},
            isAgreeData: this.getIsAgreeStatus(this.props.sowDocData),
            customerComments: [],
            showCommentsModal: false,
            sowDocCustCommentsJson: {},
            selectedDocIndex: 0,
            showAddComment: this.isCustomer(),
            buttonClicked: ""
        }
        this.customerStatus = {
            approve: "Acknowledged By Customer",
            reject: "Rejected By Customer",
            draft: "Draft",
            awaitingApproval: "Awaiting approval"
        }
        this.buttonClickedOptions = {
            approve: "Approve",
            reject: "Reject",
        }
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.sowDocData) !== JSON.stringify(nextProps.sowDocData)) {
            this.setState({
                data: nextProps.sowDocData,
                isAgreeData: this.getIsAgreeStatus(nextProps.sowDocData)
            })
        }
    }

    getIsAgreeStatus = (docStatusData = []) => {
        return docStatusData && docStatusData.length ? docStatusData.map(doc => doc.docStatus === this.customerStatus && this.customerStatus.approve) : [false]
    }

    componentWillMount() {
        /*===========================static data fetch call===========================*/
        aemHostClient("/aemData/formData/json_sow-documentation")
            .then(({ data, status }) => {
                this.setState({ pageJson: data.par });
            });

        aemHostClient("/aemData/formData/json_sow-gls-approval-comments")
            .then(({ data, status }) => {
                this.setState({ sowDocCustCommentsJson: data.par });
            });

        /*===========================Documentation finalise Modal data fetch call===========================*/
        // aemHostClient("/aemData/formData/json_documentation-finalised")
        //   .then(({ data, status }) => {
        //     this.setState({ pageJsonModal: data.par });
        //   });

        /*===================Dark title bar page json =================*/
        aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data }) => {
                this.setState({ darkTitleBarJson: data.par });
                document.title = `${Translations(data.par.static_text_darkTitleBar.documentation, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
            });
        /*===================Marked signed popup page json =================*/
        // aemHostClient("/aemData/formData/json_mark-as-signed")
        //   .then(({ data, status }) => {
        //     this.setState({ formJson: data.par })
        //   });
        // /*===========================dynamic data fetch call===========================*/
        // this.loadDocumentationPageState();
        this.props.getDocStatus()
        this.getCustomerComments()
    }

    getTranslations = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    translateWord = (word) => {
        var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
        var convertedArray = convertStringToArray(currentWord);
        return convertedArray;
    }

    renderDocumentationBanner() {
        let element = [];
        var caseSigned;
        var caseSignedDate;
        for (let i = 0; this.state.data.length > i; i++) {
            if (this.state.data[i].finalizeDate !== '' && this.state.data[i].signedDate === '') {
                caseSigned = this.getTranslations(this.state.pageJson.button_finalise && this.state.pageJson.button_finalise.name);
                caseSignedDate = this.state.data[i].finalizeDate;
            }
            else if (this.state.data[i].signedDate !== undefined && this.state.data[i].signedDate !== '') {
                caseSigned = this.translateWord(this.state.pageJson.documentation_pack_docPac && this.state.pageJson.documentation_pack_docPac.statusText)[2];
                caseSignedDate = this.state.data[i].signedDate;
            }
            else {
                caseSigned = this.getTranslations(this.state.pageJson.documentation_pack_docPac && this.state.pageJson.documentation_pack_docPac.dateLabel);
                caseSignedDate = moment(this.state.data[i].documentGenerationDate).format("DD MMM YY") || moment(this.state.data[i].createdOn).format("DD MMM YY");
            }
            element.push(
                <React.Fragment>
                    <div className={classnames({
                        "gdoc-caseDocument": true,
                        "block": this.props.caseMenu.isEditing
                    })} key={this.state.data[i].id}>
                        <h5 className="gdoc-caseDocument-Heading gdocs-responsive-text">{this.state.data[i].entityName}</h5>
                        <div className="gdoc-caseDocument-Details">
                            <div className="gdocs-float-left icon icon-pdf pdfIcon" aria-label="SOW Documentation PDF" role="img"></div>
                            <div className="gdocs-float-left gdoc-caseDocument-link">
                                <h4 className='caseDocListHead gdocs-responsive-text gdocs-float-left'>
                                    {`${this.getTranslations("SOW")} ${this.state.data[i].entityName}_${this.state.data[i].sowEntityId}_${moment(this.state.data[i].createdOn).format("HHmmss")}`}
                                    <span className="icon icon-chevron-right iconCenter" aria-hidden="true"></span>
                                </h4>
                                <div className="gdocs-clear-float"></div>
                                <div className='caseDocListDesc'>
                                    {`${caseSigned} ${caseSignedDate}`}
                                </div>
                                {this.isCustomer() ? null :
                                    <p className="gdocs-note-text">{this.getTranslations(this.state.pageJson.documentation_pack_docPac && this.state.pageJson.documentation_pack_docPac.noteText)}</p>
                                }
                            </div>
                            <div className={classnames({
                                "gdocs-float-right": true,
                                "block": this.props.caseMenu.isEditing
                            })} >
                                <div className="statusCaseDoc gdocs-float-left">{this.state.data[i].docStatus}</div>
                                <div className="separatorCaseList gdocs-float-left"></div>
                                <button aria-label="Download" style={{ background: "inherit", border: "none" }} onClick={() => { this.downloadSowDocument() }}>
                                    <i className="icon icon-download downloadIconCaseList gdocs-float-left" ref="setattr" dir="dir" ></i>
                                </button>
                            </div>
                            <div className="gdocs-clear-float"></div>
                            <article className="disclaimer-notice-wrapper">
                                <section className="disclaimer-notice">
                                    {
                                        (this.isCustomer() && !(this.state.data[i].docStatus === this.customerStatus.reject ||
                                            this.state.data[i].docStatus === this.customerStatus.approve))
                                            ?
                                            <React.Fragment>
                                                <Checkbox name={"is-agree-t-c" + i}
                                                    checked={
                                                        this.state.data[i].status === this.customerStatus.approve ||
                                                        (Array.isArray(this.state.isAgreeData) && this.state.isAgreeData[i])
                                                    }
                                                    controlled
                                                    onChange={(event) => {
                                                        const newIsAgree = [...this.state.isAgreeData]
                                                        newIsAgree[i] = event.target.checked
                                                        const data = {
                                                            isAgreeData: newIsAgree
                                                        }
                                                        this.setState({ isAgreeData: newIsAgree })
                                                    }}
                                                    disabled={this.isSowApprovedRejected(this.state.data[i]) || (this.props.isReadOnly && this.props.isReadOnly(true))}
                                                />
                                                <section>{this.getTranslations(this.state.pageJson.checkbox_confirmation && this.state.pageJson.checkbox_confirmation.text)}</section>
                                            </React.Fragment>
                                            : null
                                    }
                                </section>
                                <section>
                                    <div
                                        className={classnames("view-cust-comments-link", { "disabled": !this.isCustomer() && this.state.customerComments.length === 0 })}
                                        onClick={() => {
                                            this.setState({
                                                showCommentsModal: true,
                                                showAddComment: this.isCustomer()
                                            })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                this.setState({
                                                    showCommentsModal: true,
                                                    showAddComment: this.isCustomer()
                                                })
                                            }
                                        }}
                                        role="link"
                                        tabIndex={0}
                                    >
                                        {(this.state.pageJson.static_text_viewcomments && `${this.getTranslations(this.state.pageJson.static_text_viewcomments.label)} (${(this.state.customerComments && this.state.customerComments.length) || 0})`) || null}
                                    </div>
                                </section>
                            </article>
                        </div>
                        <div className="gdocs-clear-float"></div>

                    </div>
                    {this.isCustomer() && !(this.state.data[i].status === this.customerStatus.approve) && !this.isSowApprovedRejected(this.state.data[i]) ?
                        <section className="gdocs-display-flex">
                            <section>
                                <button className="gdocs-btn-primary gdocs-mr-1rem" disabled={!(Array.isArray(this.state.isAgreeData) && this.state.isAgreeData[i]) ||
                                    (this.props.isReadOnly && this.props.isReadOnly(true))} onClick={() => { this.handleApproveReject(i, this.buttonClickedOptions.approve) }}>
                                    {this.getTranslations((this.state.pageJson.button_approve && this.state.pageJson.button_approve.text) || this.buttonClickedOptions.approve)}
                                </button>
                            </section>
                            <section>
                                <button className="gdocs-btn-default" disabled={(this.props.isReadOnly && this.props.isReadOnly(true))} onClick={() => {
                                    this.handleApproveReject(i, this.buttonClickedOptions.reject)
                                }}>
                                    {this.getTranslations((this.state.pageJson.button_reject && this.state.pageJson.button_reject.text) || this.buttonClickedOptions.reject)}
                                </button>
                            </section>
                        </section>
                        : null}
                </React.Fragment>
            );
        }
        return element;
    }

    handleApproveReject = (docIndex, buttonClicked) => {
        this.setState({
            showCommentsModal: true,
            selectedDocIndex: docIndex,
            showAddComment: this.isCustomer(),
            buttonClicked
        })
    }

    handleUpdateCustomerComments = (pid, comment = '') => {
        const apiUrl = '/sows/addComment?isCust=true'
        const payload = [this.getCommentObject(comment)]
        this.props.blockUi && this.props.blockUi()
        eapiClient(apiUrl, {
            method: "PUT",
            data: JSON.stringify(payload)
        }).then(({ data }) => {
            this.getCustomerComments()
            this.setState({
                showAddComment: false,
                buttonClicked: ''
            })
            this.props.unBlockUi && this.props.unBlockUi()
        })
    }

    handleSowApproveRejectWithCustomerComments = (pid, comment = '') => {
        const payload = {
            comments: typeof comment === null ? [{}] : [this.getCommentObject(comment)],
            sowId: this.props.sowId,
            status: this.state.buttonClicked === this.buttonClickedOptions.approve ? this.customerStatus.approve : this.customerStatus.reject
        }
        const apiUrl = '/sows/approve-reject-sow'
        this.props.blockUi && this.props.blockUi()
        eapiClient(apiUrl, {
            method: "POST",
            data: JSON.stringify(payload)
        }).then(({ data }) => {
            this.props.getDocStatus()
            this.getCustomerComments()
            if (!isEmptyObject(data.responseData)) {
                const { comments, ...rest } = data.responseData
                this.props.setSavedSow(rest)
            }
            if (this.state.buttonClicked === this.buttonClickedOptions.approve) {
                this.props.generateSowDocumentwithPollApi && this.props.generateSowDocumentwithPollApi()
            }
            this.setState({
                showAddComment: false,
                buttonClicked: ''
            })
            this.props.unBlockUi && this.props.unBlockUi()
        })
    }

    isCustomer = () => {
        return this.props.customer
    }

    getCustomerComments = () => {
        const apiUrl = '/sows/' + this.props.sowId + '/comment?isCust=true'
        eapiClient(apiUrl).then(({ data }) => {
            if (data.responseData) {
                this.setState({
                    customerComments: data.responseData
                })
            }
        })
    }

    getCommentObject = (commentText = '') => {
        const { emailAddress = '', username = '' } = this.props.userDetail || {}
        return {
            username,
            commentText,
            email: emailAddress,
            sowId: this.props.sowId
        }
    }

    downloadSowDocument = () => {
        eapiClient(`sows/${this.props.sowId}/downloadDocument`, {
            method: 'GET',
            responseType: 'blob',
        }, { timeout: 420000 })
            .then((response, filename, mime) => {
                var blob = new Blob([response.data], { type: mime || 'application/octet-stream' });
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // IE workaround for "HTML7007: One or more blob URLs were
                    // revoked by closing the blob for which they were created.
                    // These URLs will no longer resolve as the data backing
                    // the URL has been freed."
                    // ${this.state.data[i].entityName}_${this.state.data[i].sowEntityId}_${moment(this.state.data[i].createdOn).format("HHmmss")}`

                    window.navigator.msSaveBlob(blob, `${this.state.data[0].entityName}_${this.state.data[0].sowEntityId}_${moment(this.state.data[0].createdOn).format("HHmmss")}.pdf`);
                }
                else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement('a');
                    tempLink.style.display = 'none';
                    tempLink.href = blobURL;
                    tempLink.setAttribute('download', `${this.state.data[0].entityName}_${this.state.data[0].sowEntityId}_${moment(this.state.data[0].createdOn).format("HHmmss")}.pdf`);

                    // Safari thinks _blank anchor are pop ups. We only want to set _blank
                    // target if the browser does not support the HTML5 download attribute.
                    // This allows you to download files in desktop safari if pop up blocking
                    // is enabled.
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank');
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                }
            });
    }

    isSowApprovedRejected = (doc = {}) => {
        return checkValueExistInObject(doc, [this.customerStatus.approve, this.customerStatus.reject])
    }

    handleShowNoCommentCheckbox = () => {
        return this.isCustomer() && !this.isSowApprovedRejected(this.state.data && this.state.data[this.state.selectedDocIndex]) && this.state.buttonClicked
    }

    getDynamicPropsForAddViewCommentModal = (props) => {
        let title = this.state.sowDocCustCommentsJson.page_title_mainTitle ? this.getTranslations(this.state.sowDocCustCommentsJson.page_title_mainTitle.sowPageHeading) : ''
        let addCommentBtn = this.state.sowDocCustCommentsJson.button_addComment ? this.getTranslations(this.state.sowDocCustCommentsJson.button_addComment.text) : "Add comment"
        if (!this.isSowApprovedRejected(this.state.data && this.state.data[this.state.selectedDocIndex]) && this.state.buttonClicked) {
            title = title + (this.state.buttonClicked === this.buttonClickedOptions.approve ? " - Approval" : " - Rejection")
            addCommentBtn = this.state.buttonClicked
        }
        const dynamicProps = {
            addCommentBtn: addCommentBtn,
            modalTitle: title
        }
        return dynamicProps[props]
    }

    handleAddComment = (pid, comment) => {
        return this.state.buttonClicked === '' || this.isSowApprovedRejected(this.state.data && this.state.data[this.state.selectedDocIndex])
            ? this.handleUpdateCustomerComments(pid, comment)
            : this.handleSowApproveRejectWithCustomerComments(pid, comment);
    }

    render() {
        return (
            <React.Fragment>
                <article className="gdoc-caseDocument-container sow-documentation">
                    {this.renderDocumentationBanner()}
                </article>
                <AddViewComments
                    bsClass="comments-modal sow-comments"
                    showDialog={this.state.showCommentsModal}
                    toggleDialog={() => this.setState({ showCommentsModal: false, buttonClicked: '' })}
                    // modalTitle={this.getTranslations(this.state.sowDocCustCommentsJson.page_title_mainTitle && this.state.sowDocCustCommentsJson.page_title_mainTitle.sowPageHeading)}
                    modalTitle={this.getDynamicPropsForAddViewCommentModal("modalTitle")}
                    product={{
                        glsProductType: {},
                        glsAgent: {},
                        id: '',
                    }}
                    addCommentLabel={this.getTranslations(this.state.sowDocCustCommentsJson.static_text_addANewComment && this.state.sowDocCustCommentsJson.static_text_addANewComment.title)}
                    addCommentBtn={this.getDynamicPropsForAddViewCommentModal("addCommentBtn")}
                    prevCommentsLabel="Previous comments"
                    comments={this.state.customerComments || []}
                    _onAddComment={this.handleAddComment}
                    hideFooter
                    sow
                    showAddComment={this.state.showAddComment}
                    from="sow-documentation-tab"
                    noCommentProps={
                        {
                            show: this.handleShowNoCommentCheckbox(),
                            name: this.state.sowDocCustCommentsJson.checkbox_noComments && this.state.sowDocCustCommentsJson.checkbox_noComments.name,
                            text: this.getTranslations(this.state.sowDocCustCommentsJson.checkbox_noComments && this.state.sowDocCustCommentsJson.checkbox_noComments.text)
                        }
                    }
                />
            </React.Fragment>

        )
    }

}

const mapDispatchToProps = (dispatch) => {
    return {
        setSavedSow: data => {
            dispatch(setSavedSow(data))
        },
        blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        }
    }
}
export default connect(null, mapDispatchToProps)(SowDocumentation)



// WEBPACK FOOTER //
// ./src/components/SowBody/SowDocumentation/index.js